import { Howl } from 'howler'
import { IframeContextState } from '../IframeConn'
import { NotificationsContextState } from '../Notifications'
import { Chat, Message } from './types'

const sounds = [1, 2, 3, 4, 5, 6, 7].reduce((all, number) => {
  all[number] = new Howl({
    src: [`/sounds/notification_sound${number}.mp3`],
  })

  return all
}, {} as { [key: number]: Howl })

const playSound = () => {
  if (window.c.notificationSound) {
    sounds[window.c.notificationSound].play()
  }
}

export const notifyNewChat = (
  iframeContextSate: IframeContextState,
  notificationsContextState: NotificationsContextState
) => {
  notificationsContextState.notify(
    intl.formatMessage({ id: 'notification / new chat' })
  )
  iframeContextSate.parentRef.current?.open()

  playSound()
}

export const notifyNewMessage = (
  messages: Message[],
  chat: Chat,
  notificationsContextState: NotificationsContextState
) => {
  const message = messages.find(m => m.type == 'CLIENT')

  if (message) {
    notificationsContextState.notify(message.content, chat.client.name)

    playSound()
  }
}

// function* notificationSaga() {
//   yield [fork(notificationNewMessage), fork(notificationNewChat)]

//   function* notificationNewMessage() {
//     yield takeEvery([NEW_MESSAGES], function* (action) {
//       const message = action.messages.find(message => message.type == 'CLIENT')

//       if (!message) return

//       const chat = yield select(state =>
//         state.app.chats.find(v => v.id == action.id)
//       )

//       var e = new Event('lim-notification')
//       e._type = window.NOTIFICATIONS_CHAT
//       e.title = chat.client.name
//       e.sound = true

//       if (typeof message.content == 'string') {
//         e.content = message.content
//       }

//       document.dispatchEvent(e)
//     })
//   }

//   function* notificationNewChat() {
//     yield takeEvery([NEW_CHAT], function* (action) {
//       console.log('-~-', 'nowy czat')

//       var e = new Event('lim-notification')
//       e._type = window.NOTIFICATIONS_CHAT
//       e.title = action.chat.client.name
//       e.content = intl.formatMessage({ id: 'chat.notification.new' })
//       e.sound = true
//       document.dispatchEvent(e)
//     })
//   }
// }
